import PropTypes from "prop-types";
import { useState, useEffect } from "react";

const UserAsistenciaVerForm = ({ user, getAsistenciaByUser_Id }) => {
  const [asistenciasList, setAsistenciasList] = useState([]); // Ensure it's initialized as an array

  useEffect(() => {
    const userId = user?.id_usuario;

    const fetchAsistencias = async () => {
      if (!userId) return; // Prevent fetching if userId is not valid
      try {
        const asistenciasData = await getAsistenciaByUser_Id(userId);
        setAsistenciasList(Array.isArray(asistenciasData.data) ? asistenciasData.data : []); // Ensure asistenciasList is always an array
      } catch (error) {
        console.error("Error fetching asistencias:", error);
        setAsistenciasList([]); // Reset to an empty array in case of an error
      }
    };

    fetchAsistencias();
  }, [user, getAsistenciaByUser_Id]);

  // Función para formatear la fecha
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
  
    // Crear fecha como UTC
    const utcDate = new Date(dateString);
  
    // Ajustar a GMT-6 (360 minutos = 6 horas)
    const localDate = new Date(utcDate.getTime() + 24 * 60 * 60 * 1000);
  
    // Formatear la fecha a 'DD-MM-YYYY'
    return localDate.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div >
      <h3>Asistencias Encontrados:</h3>
      <table border="1" className="table">
        <thead className="table-th">
          <tr>
            <th>Fecha</th>
            <th>Ruta</th>
            <th>Validado por</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(asistenciasList) && asistenciasList.length > 0 ? (
            asistenciasList.map((asistencia, index) => (
              <tr key={index} >
                <td>{formatDate(asistencia.fecha)}</td>
                <td width="350px">{asistencia.id_ruta}</td>
                <td>{asistencia.lider_id}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3">No asistencias found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
  
};

UserAsistenciaVerForm.propTypes = {
  user: PropTypes.object.isRequired, // Expecting an array of user objects
  asistencias: PropTypes.array,
  getAsistenciasByUser_Id: PropTypes.func,
};

export default UserAsistenciaVerForm;
